// The screens this app has. See docs/BUILD-CONTRACT.md for who owns each page.
//
// router.js belongs to the navigation shell; this file is the product's list.
// `primary` marks the screen the app opens on; `destination` marks top-level
// screens someone navigates TO (reached from the Pager screen's header).

import PagerPage from './pages/PagerPage.vue';
import ThreadPage from './pages/ThreadPage.vue';
import ComposePage from './pages/ComposePage.vue';
import FriendsPage from './pages/FriendsPage.vue';
import DevicesPage from './pages/DevicesPage.vue';
import SettingsPage from './pages/SettingsPage.vue';
import InvitePage from './pages/InvitePage.vue';
import GroupPage from './pages/GroupPage.vue';

export const PRODUCT_ROUTES = [
  { id: 'pager', path: '/tabs/pager', label: 'Pager', component: PagerPage, primary: true },
  { id: 'friends', path: '/tabs/friends', label: 'Friends', component: FriendsPage, primary: false, destination: true },
  { id: 'devices', path: '/tabs/devices', label: 'Devices', component: DevicesPage, primary: false, destination: true },
  { id: 'settings', path: '/tabs/settings', label: 'Settings', component: SettingsPage, primary: false, destination: true, settings: true },
  { id: 'thread', path: '/tabs/thread/:number', label: 'Thread', component: ThreadPage, primary: false },
  { id: 'group', path: '/tabs/group/:id', label: 'Group', component: GroupPage, primary: false },
  { id: 'compose', path: '/tabs/compose/:number?', label: 'New page', component: ComposePage, primary: false },
  { id: 'invite', path: '/tabs/add/:code', label: 'Invite', component: InvitePage, primary: false },
];

export const PRIMARY_ROUTES = PRODUCT_ROUTES.filter((r) => r.primary);
export const DESTINATION_ROUTES = PRODUCT_ROUTES.filter((r) => r.destination ?? r.primary).slice(0, 5);
export const HOME_ROUTE = (PRIMARY_ROUTES[0] ?? PRODUCT_ROUTES[0])?.path ?? '/';
